import styled from 'styled-components';

const StyledAccordionContent = styled.div`
  position: relative;
  width: 100%;
  flex: ${props => props.isDouble ? '0 0 48%' : 'auto'};
  .inner-title, .inner-text { 
    padding-bottom: 40px;
  }
  @media screen and (max-width: 1439px){
    
  }
  @media screen and (max-width: 1023px){
    
  }
  @media screen and (max-width: 767px){
    flex: ${props => props.isDouble ? '0 0 100%' : 'auto'};
  }
`;

export {
  StyledAccordionContent,
};

